import * as React from 'react';
import { ICartItem } from '../../../interfaces/checkout/cart/cartType';
import { IOptionItem } from '../../../interfaces/checkout/cart/IOptionItem';
import { empty } from '../../../helpers/empty';

export const getItemShowExtraTerms = (item: ICartItem) => {
    const optionItems: IOptionItem = item.options ? JSON.parse(item.options) : {};
    return optionItems.extra_terms && !empty(optionItems.extra_terms.value);
};
